module.exports = __webpack_public_path__ + "img/xx.04b58170.png";